module.exports = __webpack_public_path__ + "img/downloadBack.9e559d44.png";